<div
    class="inner-content dark:rounded-2xl dark:border-2 dark:border-solid dark:border-contrast-yellow dark:bg-contrast-black"
    ridangoAppTrapFocus>
    <!-- Header -->
    <div class="relative mx-3.5 !flex items-center justify-center">
        <p
            class="var-app-light-dark:font-bold orb-app-light-dark:font-bold px-6 py-5 text-base font-semibold leading-5">
            {{ 'EDIT_FAVORITES' | translate }}
        </p>
        <button
            class="!absolute right-0"
            [attr.aria-label]="('CLOSE_ARIA_LABEL' | translate) + ('EDIT_FAVORITES' | translate)"
            (click)="cancel()"
            tabindex="0"
            mat-icon-button>
            <mat-icon class="vl-app-light:font-bold text-2xl">close</mat-icon>
        </button>
    </div>

    <div class="border-ironside_grey-100 !flex border-t border-solid dark:border-contrast-yellow"></div>

    <!-- Content -->
    <div class="content w-full overflow-y-auto">
        <!-- Favorite Stops -->
        <ng-container *ngIf="favoriteStops?.length > 0">
            <ng-container *ngFor="let item of favoriteStops; let i = index">
                <mat-divider *ngIf="i !== 0"></mat-divider>
                <div class="flex items-center p-3.5">
                    <ion-icon
                        class="orb-app-light:text-secondary vl-app-light:text-black mr-3.5 h-8 w-8 flex-shrink-0 text-white dark:text-contrast-yellow"
                        [src]="stopIconPath | async"
                        aria-hidden="true"></ion-icon>
                    <p class="min-w-0 flex-1 break-words text-base leading-5">
                        {{ item.alias || item.name }}
                        <span *ngIf="item?.desc && env.EXPLORE?.SHOW_MUNICIPALITY_IN_STOP_NAME">({{ item.desc }})</span>
                    </p>
                    <ng-container
                        *ngTemplateOutlet="
                            deleteButton;
                            context: {
                                label: getRemoveAriaLabel(item.alias || item.name),
                                onClick: handleDeleteFavoriteStop.bind(this, item),
                                isFirst: i === 0
                            }
                        "></ng-container>
                </div>
            </ng-container>
        </ng-container>

        <!-- Favorite Locations -->
        <ng-container *ngIf="favoriteLocations?.length > 0">
            <ng-container *ngFor="let location of favoriteLocations; let i = index">
                <mat-divider *ngIf="shouldShowDivider(i, favoriteStops?.length > 0)"></mat-divider>
                <div
                    class="flex items-center p-3.5"
                    [ngClass]="{ 'vl-app-light-dark:pl-2': !location.pointOfInterest }">
                    <ion-icon
                        class="orb-app-light:text-grey-zambezy mr-3.5 h-8 w-8 flex-shrink-0 text-grey-white_smoke dark:text-contrast-yellow"
                        [src]="
                            (assetsPath$ | async) +
                            (location.pointOfInterest ? '/img/explore/poi.svg' : imageMapLocationPath)
                        "
                        aria-hidden="true"></ion-icon>
                    <p class="min-w-0 flex-1 break-words text-base leading-5">{{ location.name }}</p>
                    <ng-container
                        *ngTemplateOutlet="
                            deleteButton;
                            context: {
                                label: getRemoveAriaLabel(location.name),
                                onClick: handleDeleteFavoriteLocation.bind(this, location)
                            }
                        "></ng-container>
                </div>
            </ng-container>
        </ng-container>

        <!-- Favorite Schedules -->
        <ng-container *ngIf="favoriteSchedules?.length > 0">
            <ng-container *ngFor="let item of favoriteSchedules; let i = index">
                <mat-divider
                    *ngIf="
                        shouldShowDivider(i, favoriteStops?.length > 0 || favoriteLocations?.length > 0)
                    "></mat-divider>
                <div class="flex-align-center flex p-3.5">
                    <rwidget-route-short-name
                        [label]="item.route?.shortName"
                        [color]="item.route?.color"></rwidget-route-short-name>
                    <p class="flex-1 truncate text-base leading-5">{{ item.stop?.name || item.route?.longName }}</p>
                    <ng-container
                        *ngTemplateOutlet="
                            deleteButton;
                            context: {
                                label: getRemoveAriaLabel(item.stop?.name || item.route?.longName),
                                onClick: handleDeleteFavoriteSchedule.bind(this, item)
                            }
                        "></ng-container>
                </div>
            </ng-container>
        </ng-container>
    </div>

    <div class="border-ironside_grey-100 !flex border-t border-solid dark:border-contrast-yellow"></div>

    <!-- Footer -->
    <div class="m-4 !flex">
        <button
            class="vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black var-app-light:text-primary orb-app-light:text-black orb-app-light:bg-primary h-14 w-full rounded-lg bg-secondary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
            [attr.aria-label]="'SAVE' | translate"
            (click)="handleSaveClick()">
            {{ 'SAVE' | translate }}
        </button>
    </div>
</div>

<!-- ========== TEMPLATES ========== -->

<!-- Delete Button Template -->
<ng-template #deleteButton let-label="label" let-onClick="onClick" let-isFirst="isFirst">
    <button
        class="flex-shrink-0 leading-none"
        [attr.aria-label]="label"
        [attr.ridangoAutofocus]="isFirst ? 'true' : null"
        (click)="onClick()"
        mat-icon-button>
        <!-- Close Icon (default) -->
        <mat-icon
            class="vl-app-light:text-primary-danger vl-app-light:font-bold var-app-light:text-primary-danger var-app-light:font-bold scale-75"
            *ngIf="!useTrashIcon"
            aria-hidden="true"
            >close</mat-icon
        >
        <!-- Trash Bin Icon (alternative) -->
        <mat-icon
            class="text-primary-danger h-8 w-8"
            *ngIf="useTrashIcon"
            svgIcon="trash-bin"
            aria-hidden="true"></mat-icon>
    </button>
</ng-template>
